package com.evoapps.evoshift.ui.user

import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.widgets.SurfaceCard
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.LocalTopBarSelection
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.domain.model.LedgerKind
import com.evoapps.evoshift.ui.finance.LedgerKindToggle
import com.evoapps.evoshift.ui.finance.RevenueGreen
import com.evoapps.evoshift.ui.finance.ledgerAmount
import com.evoapps.evoshift.ui.finance.ledgerKindLabel
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.ui.finance.formatMoney
import com.evoapps.evoshift.viewmodels.WorkplaceInfo
import com.evoapps.evoshift.widgets.formatEditable
import evoshift.composeapp.generated.resources.cost_rules_delete_confirm
import evoshift.composeapp.generated.resources.number_invalid
import evoshift.composeapp.generated.resources.field_required
import evoshift.composeapp.generated.resources.save
import com.evoapps.evoshift.widgets.parseDecimal
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoDropdown
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.DialogAction
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.material.icons.filled.Repeat
import androidx.compose.material.icons.automirrored.filled.CallSplit
import evoshift.composeapp.generated.resources.cost_rules_convert
import com.evoapps.evoshift.ui.util.asString
import evoshift.composeapp.generated.resources.cost_rules_add_title
import evoshift.composeapp.generated.resources.cost_rules_applies_to
import evoshift.composeapp.generated.resources.cost_rules_edit_title
import evoshift.composeapp.generated.resources.select_workplace
import evoshift.composeapp.generated.resources.unknown_workplace
import com.evoapps.evoshift.ui.util.label
import evoshift.composeapp.generated.resources.back
import evoshift.composeapp.generated.resources.confirm
import evoshift.composeapp.generated.resources.cost_rules_add
import evoshift.composeapp.generated.resources.cost_rules_amount
import evoshift.composeapp.generated.resources.cost_rules_empty
import evoshift.composeapp.generated.resources.cost_rules_empty_hint
import evoshift.composeapp.generated.resources.cost_rules_frequency
import evoshift.composeapp.generated.resources.cost_rules_one_off_hint
import evoshift.composeapp.generated.resources.cost_rules_name_hint
import evoshift.composeapp.generated.resources.cost_rules_title
import evoshift.composeapp.generated.resources.cost_rules_workplace
import evoshift.composeapp.generated.resources.delete
import evoshift.composeapp.generated.resources.edit
import evoshift.composeapp.generated.resources.name
import org.jetbrains.compose.resources.stringResource
import evoshift.composeapp.generated.resources.Res
import com.evoapps.evoshift.ui.adaptive.AdaptiveCardGrid
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.CostFrequency
import com.evoapps.evoshift.domain.model.RecurringCostRule
import com.evoapps.evoshift.viewmodels.RecurringCostRulesEvent
import com.evoapps.evoshift.viewmodels.RecurringCostRulesViewModel
import com.evoapps.evoshift.widgets.LoadingOverlay

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun RecurringCostRulesScreen(
    viewModel: RecurringCostRulesViewModel,
    onNavigateBack: () -> Unit,
    /** SH-131: "Convert to a shared cost" on a monthly cost (the owner's shared costs screen). */
    onConvertToShared: ((String) -> Unit)? = null
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    
    var showEditDialog by remember { mutableStateOf<RecurringCostRule?>(null) }
    var ruleToDelete by remember { mutableStateOf<RecurringCostRule?>(null) }
    var showAddDialog by remember { mutableStateOf(false) }
    // SH-89: the rules of the top bar's workplace (one the person owns); else all of them.
    val barWorkplaceId = LocalTopBarSelection.current?.workplaceId?.takeIf { it in state.workplaces }
    // Not remembered: a repository may hand back the same (changed) list.
    val rules = if (barWorkplaceId == null) state.rules else state.rules.filter { it.targetWorkplaceId == barWorkplaceId }

    val errorText = state.error?.asString()

    val successText = state.successMessage?.asString()

    LaunchedEffect(errorText, successText) {
        errorText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(RecurringCostRulesEvent.MessageShown)
        }
        successText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(RecurringCostRulesEvent.MessageShown)
        }
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                // SH-89: the rules of the bar's workplace (an owner's other workplaces: switch there).
                title = stringResource(Res.string.cost_rules_title),
                onBack = onNavigateBack,
                showWorkplace = true,
                actions = listOf(helpAction(HelpPage.FIXED_COSTS))
            )
        },
        floatingActionButton = {
            // A rule needs a workplace the person owns to target.
            if (state.workplaces.isNotEmpty()) FloatingActionButton(onClick = { showAddDialog = true }) {
                Icon(Icons.Default.Add, contentDescription = stringResource(Res.string.cost_rules_add))
            }
        }
    ) { padding ->
        Box(modifier = Modifier.padding(padding).fillMaxSize()) {
            if (rules.isEmpty() && !state.isLoading) {
                Column(
                    modifier = Modifier.align(Alignment.Center).padding(24.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(stringResource(Res.string.cost_rules_empty), style = MaterialTheme.typography.bodyLarge)
                    Text(stringResource(Res.string.cost_rules_empty_hint), style = MaterialTheme.typography.bodyMedium, color = MaterialTheme.colorScheme.onSurfaceVariant)
                }
            } else {
                // One column on phones; two or three columns of rules on tablets and desktops.
                AdaptiveCardGrid(
                    modifier = Modifier.fillMaxSize(),
                    contentPadding = PaddingValues(16.dp),
                    maxWidth = WideContentMaxWidth
                ) {
                    items(rules, key = { it.id }) { rule ->
                        Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                            val workplace = state.workplaces[rule.targetWorkplaceId]
                            CostRuleCard(
                                rule = rule,
                                currency = workplace?.currency ?: rule.currency,
                                workplaceName = workplace?.name ?: stringResource(Res.string.unknown_workplace),
                                onEdit = { showEditDialog = rule },
                                onDelete = { ruleToDelete = rule },
                                // SH-131: an owner cost entered per workplace can become a shared cost once.
                                onConvert = onConvertToShared?.takeIf {
                                    rule.kind == LedgerKind.COST && rule.frequency != CostFrequency.ONE_OFF && state.workplaces.size > 1
                                }?.let { convert -> { convert(rule.id) } }
                            )
                        }
                    }
                    item(span = { GridItemSpan(maxLineSpan) }) { Spacer(modifier = Modifier.height(80.dp)) }
                }
            }

            // Only the first load covers the list; saves update it in place.
            LoadingOverlay(isLoading = state.isLoading && state.rules.isEmpty())
        }
    }

    if (showAddDialog) {
        AddEditRuleDialog(
            title = stringResource(Res.string.cost_rules_add_title),
            workplaces = state.workplaces,
            defaultWorkplaceId = barWorkplaceId,
            onDismiss = { showAddDialog = false },
            onConfirm = { name, amount, freq, workplaceId, kind ->
                viewModel.onEvent(RecurringCostRulesEvent.AddRule(name, amount, freq, workplaceId, kind))
                showAddDialog = false
            }
        )
    }

    ruleToDelete?.let { rule ->
        EvoConfirmDialog(
            title = stringResource(Res.string.delete),
            text = stringResource(Res.string.cost_rules_delete_confirm, rule.name),
            confirmLabel = stringResource(Res.string.delete),
            onConfirm = {
                viewModel.onEvent(RecurringCostRulesEvent.DeleteRule(rule.id))
                ruleToDelete = null
            },
            onDismiss = { ruleToDelete = null },
            destructive = true,
            icon = Icons.Default.Delete
        )
    }

    if (showEditDialog != null) {
        val ruleToEdit = showEditDialog!!
        AddEditRuleDialog(
            title = stringResource(Res.string.cost_rules_edit_title),
            rule = ruleToEdit,
            workplaces = state.workplaces,
            onDismiss = { showEditDialog = null },
            onConfirm = { name, amount, freq, workplaceId, kind ->
                viewModel.onEvent(RecurringCostRulesEvent.UpdateRule(
                    ruleToEdit.copy(
                        name = name,
                        amount = amount,
                        frequency = freq,
                        targetWorkplaceId = workplaceId,
                        kind = kind
                    )
                ))
                showEditDialog = null
            }
        )
    }
}

@Composable
fun CostRuleCard(
    rule: RecurringCostRule,
    currency: String,
    workplaceName: String,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    onConvert: (() -> Unit)? = null
) {
    SurfaceCard(
        modifier = Modifier.fillMaxWidth()
    ) {
        Row(
            modifier = Modifier.padding(16.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text(text = rule.name, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
                // SH-87: the kind, and revenue in green with a "+".
                Text(
                    text = "${ledgerKindLabel(rule.kind)} · ${ledgerAmount(rule.amount, rule.kind, currency)} / ${rule.frequency.label()}",
                    style = MaterialTheme.typography.bodyMedium,
                    color = if (rule.kind == LedgerKind.REVENUE) RevenueGreen else MaterialTheme.colorScheme.primary
                )
                Text(
                    text = stringResource(Res.string.cost_rules_applies_to, workplaceName),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }
            
            onConvert?.let { convert ->
                IconButtonWithTooltip(onClick = convert, tooltip = stringResource(Res.string.cost_rules_convert)) {
                    Icon(Icons.AutoMirrored.Filled.CallSplit, contentDescription = stringResource(Res.string.cost_rules_convert), modifier = Modifier.size(20.dp))
                }
            }
            IconButtonWithTooltip(onClick = onEdit, tooltip = stringResource(Res.string.edit)) {
                Icon(Icons.Default.Edit, contentDescription = stringResource(Res.string.edit), modifier = Modifier.size(20.dp))
            }
            IconButtonWithTooltip(onClick = onDelete, tooltip = stringResource(Res.string.delete)) {
                Icon(Icons.Default.Delete, contentDescription = stringResource(Res.string.delete), modifier = Modifier.size(20.dp), tint = MaterialTheme.colorScheme.error)
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AddEditRuleDialog(
    title: String,
    rule: RecurringCostRule? = null,
    workplaces: Map<String, WorkplaceInfo>,
    onDismiss: () -> Unit,
    onConfirm: (String, Double, CostFrequency, String, LedgerKind) -> Unit,
    /** A new rule's workplace: the top bar's (SH-89). */
    defaultWorkplaceId: String? = null
) {
    var name by remember { mutableStateOf(rule?.name ?: "") }
    var amountText by remember { mutableStateOf(rule?.amount?.let { formatEditable(it) } ?: "") }
    var frequency by remember { mutableStateOf(rule?.frequency ?: CostFrequency.MONTHLY) }
    var kind by remember { mutableStateOf(rule?.kind ?: LedgerKind.COST) }
    var targetWorkplaceId by remember { mutableStateOf(rule?.targetWorkplaceId ?: defaultWorkplaceId ?: workplaces.keys.firstOrNull() ?: "") }
    var tried by remember { mutableStateOf(false) }

    val amount = parseDecimal(amountText)
    val required = stringResource(Res.string.field_required)
    val currency = workplaces[targetWorkplaceId]?.currency ?: "PLN"

    EvoDialog(
        title = title,
        icon = Icons.Default.Repeat,
        onDismiss = onDismiss,
        confirm = DialogAction(
            stringResource(Res.string.save),
            {
                tried = true
                if (name.isNotBlank() && amount != null && targetWorkplaceId.isNotBlank()) {
                    onConfirm(name.trim(), amount, frequency, targetWorkplaceId, kind)
                }
            }
        )
    ) {
        LedgerKindToggle(kind) { kind = it }
        EvoTextField(
            value = name,
            onValueChange = { name = it },
            label = stringResource(Res.string.name),
            placeholder = stringResource(Res.string.cost_rules_name_hint),
            error = required.takeIf { tried && name.isBlank() }
        )
        EvoTextField(
            value = amountText,
            onValueChange = { amountText = it },
            label = stringResource(Res.string.cost_rules_amount, currency),
            keyboardType = KeyboardType.Decimal,
            imeAction = ImeAction.Done,
            suffix = currency,
            error = when {
                amountText.isNotBlank() && amount == null -> stringResource(Res.string.number_invalid)
                tried && amountText.isBlank() -> required
                else -> null
            }
        )
        EvoDropdown(
            label = stringResource(Res.string.cost_rules_frequency),
            // SH-84: a one-off expense is added to its month (Financials), never as a rule; an
            // old one-off rule that could not move yet keeps its value until it is changed.
            options = CostFrequency.entries.filter { it != CostFrequency.ONE_OFF || rule?.frequency == CostFrequency.ONE_OFF },
            selected = frequency,
            onSelected = { frequency = it },
            optionLabel = { it.label() },
            supportingText = stringResource(Res.string.cost_rules_one_off_hint)
        )
        if (workplaces.isNotEmpty()) {
            EvoDropdown(
                label = stringResource(Res.string.cost_rules_workplace),
                options = workplaces.keys.toList(),
                selected = targetWorkplaceId.takeIf { it in workplaces },
                onSelected = { targetWorkplaceId = it },
                optionLabel = { workplaces[it]?.name ?: it },
                placeholder = stringResource(Res.string.select_workplace),
                error = required.takeIf { tried && targetWorkplaceId.isBlank() }
            )
        }
    }
}
